import * as validator from './validator'

export default {
    ...validator
}
